import { render } from "./step-additional-documents.vue?vue&type=template&id=17499ad2"
import script from "./step-additional-documents.vue?vue&type=script&lang=ts"
export * from "./step-additional-documents.vue?vue&type=script&lang=ts"
script.render = render

export default script